import { render, staticRenderFns } from "./realtimeCall.vue?vue&type=template&id=575d23b0&scoped=true&"
import script from "./realtimeCall.vue?vue&type=script&lang=js&"
export * from "./realtimeCall.vue?vue&type=script&lang=js&"
import style0 from "./realtimeCall.vue?vue&type=style&index=0&id=575d23b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575d23b0",
  null
  
)

export default component.exports